import React from 'react';
import { AdjustmentBucket } from 'model/salesDashboard';
import { AdjustmentBucketChart } from '../Common/AdjustmentBucketChart';

interface RefundsChartProps {
    data?: AdjustmentBucket;
    isLoading?: boolean;
}

export const RefundsChart: React.FC<RefundsChartProps> = ({ data, isLoading }) => (
    <AdjustmentBucketChart
        data={data}
        isLoading={isLoading}
        title="Refunds"
    />
);
